"use client";

import { TrendOddsMobile } from "@/components/OddsTrendBadge";
import { mobileOddsBgClass } from "@/components/LiveScoreMatch/oddsTrendClasses";

const HANDICAP_BEFORE_LABELS = ["Chủ", "Hòa", "Khách"];

export default function LiveScoreOddsMobileCell({
  tdM,
  cellIdx,
  value,
  trend,
  oddsMobileCol,
}) {
  const bg = mobileOddsBgClass(trend);
  const beforeLabel = cellIdx < 3 ? HANDICAP_BEFORE_LABELS[cellIdx] : undefined;
  const tdCls = cellIdx > 2 ? `${tdM} hidden` : tdM;
  const gridColClass = cellIdx < 3 ? oddsMobileCol[cellIdx] : "";

  return (
    <td className={`${tdCls} group relative text-center`}>
      <div className={`relative mx-auto w-full ${gridColClass}`}>
        <p
          className={`relative m-0 flex h-[30px] w-full min-w-0 cursor-pointer items-stretch rounded-[4px] text-[12px] font-semibold ${bg}`}
        >
          <span className="kbv-cs-handicap-label flex w-[36px] shrink-0 items-center justify-center whitespace-nowrap px-0.5 text-[10px] font-normal leading-none">
            {beforeLabel ?? ""}
          </span>
          <span className="kbv-cs-text-away-team flex min-w-0 flex-1 items-center justify-center px-0.5 text-center leading-none">
            {value || "-"}
          </span>
          <span className="flex w-6 shrink-0 items-center justify-center">
            <TrendOddsMobile trend={trend} />
          </span>
        </p>
      </div>
    </td>
  );
}
